import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorImage from './Error.png';
import styles from './Error.scss';

export default function Error() {
  const { t } = useTranslation();
  const heading = t('Error.IeNotSupported.Header', { defaultValue: 'Internet Explorer is not supported' });
  const body = t('Error.IeNotSupported.Body', {
    defaultValue: 'Return to this page while using Microsoft Edge, Google Chrome, or another modern web browser'
  });
  const altText = `${heading}. ${body}.`;

  return (
    <div className={styles.ieNotSupported}>
      <img src={ErrorImage} alt={altText} data-testid="errorImage" />
      <div className={styles.heading} data-testid="errorHeading">
        {heading}
      </div>
      <div className={styles.body} data-testid="errorBody">
        {body}
      </div>
    </div>
  );
}
